import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { ac, roles } from "./permissions";

// ImpactOT auth client — exposes session hooks and admin operations.
// The adminClient plugin is wired with the same ac + roles used server-side
// so that client-side permission checks (authClient.admin.hasPermission,
// authClient.admin.checkRolePermission) use the identical RBAC definitions.
export const authClient = createAuthClient({
  plugins: [
    adminClient({
      ac,
      roles,
    }),
  ],
});
